import React from 'react';
import { Loader2, MoreHorizontal } from 'lucide-react';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';

const BTN = 'flex-shrink-0 h-11 min-w-[44px] px-2.5 sm:px-3 bg-white border-[#D1D5DB] text-[#374151] hover:bg-gray-50 hover:text-[#111827]';

// Neutral outline actions. Desktop: one scrollable row. Mobile (<768px): `primary` actions stay, the rest sit in "More".
export const QuotationActionBar = ({ actions }) => {
  const items = actions.filter((a) => !a.hidden);
  const rest = items.filter((a) => !a.primary);
  return (
    <div className="flex flex-nowrap items-center gap-2 overflow-x-auto pb-1 print:hidden" data-testid="quotation-action-bar">
      {items.map(({ id, label, icon: Icon, onClick, disabled, loading, title, primary }) => (
        <Button key={id} variant="outline" size="sm" onClick={onClick} disabled={disabled} title={title}
          className={`${BTN} ${primary ? '' : 'hidden md:inline-flex'}`} data-testid={id}>
          {loading ? <Loader2 className="w-[18px] h-[18px] animate-spin" /> : <Icon className="w-[18px] h-[18px] mr-1" />}
          <span>{label}</span>
        </Button>
      ))}
      {rest.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className={`${BTN} md:hidden`} data-testid="action-more-btn" title="More actions">
              <MoreHorizontal className="w-[18px] h-[18px]" /><span className="sr-only">More</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[200px]">
            {rest.map(({ id, label, icon: Icon, onClick, disabled }) => (
              <DropdownMenuItem key={id} onSelect={onClick} disabled={disabled} className="min-h-[44px] gap-2 text-[#374151]" data-testid={`more-${id}`}>
                <Icon className="w-[18px] h-[18px]" />{label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
